<template>
  <div></div>
</template>
<script>
import io from "socket.io-client";
export default {
  props: ["focusEvent"],
  data: () => ({
    socket: ""
  }),
  methods: {
    disconnect() {
      let thisVm = this;
      if (this.socket) {
        thisVm.socket.disconnect();
      }
    }
  },
  mounted() {
    this.socket = io(this.$config.socketUrl, {
      query: {}
    });

    let thisVm = this;
    this.socket.on("connect", () => {
      console.log("socket.id:" + thisVm.socket.id); // 'G5p5...'
      thisVm.socket.emit("joinRoom", thisVm.$my.getClinic());
    });

    this.socket.on("joinRoom", () => {
      console.log("joinRoom ack");
    });

    console.log("this.focusEvent:" + this.focusEvent);
    this.focusEvent.forEach(event => {
      thisVm.socket.on(event, data => {
        console.log(`${event} ack:` + JSON.stringify(data));
        thisVm.$emit("onReceive", event, data);
      });
    });

    this.socket.on("disconnect", () => {
      console.log("socket disconnect"); // 'G5p5...';
    });
  },
  beforeDestroy() {
    this.disconnect();
  }
};
</script>

<style></style>
